import { createAsyncThunk } from '@reduxjs/toolkit';
import * as types from 'types';
import { outputCsvData as outputCsvDataService } from 'services/csv-output';

export const outputCsvData = createAsyncThunk<
  types.OutputCsvResponse,
  types.OutputCsvRequest,
  types.ThunkAPI<types.OutputCsvError>
>('csv-output/post', async (params, { rejectWithValue }) => {
  try {
    const { data } = await outputCsvDataService(params);
    return data;
  } catch (error: any) {
    return rejectWithValue({
      message: error?.response?.data?.message || 'CSV出力に失敗しました。',
    });
  }
});
